import { render, staticRenderFns } from "./shenheYuceCrm.vue?vue&type=template&id=35078415&scoped=true"
import script from "./shenheYuceCrm.vue?vue&type=script&lang=js"
export * from "./shenheYuceCrm.vue?vue&type=script&lang=js"
import style0 from "./shenheYuceCrm.vue?vue&type=style&index=0&id=35078415&prod&scoped=true&lang=css"
import style1 from "./shenheYuceCrm.vue?vue&type=style&index=1&id=35078415&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35078415",
  null
  
)

export default component.exports